import { useCallback, useMemo } from 'react';
import { Role } from '../../types';


export const useTabs = (
    setTabSelect: (role: Role) => void,
    tabSelect: Role | null,
    perfil: string,
    ) => {
    // Acá podés definir los roles como quieras, hardcodeados o traídos de algún lado
    /* const roles: Role[] = useMemo(        
        () => [
        { id: 1, name: 'Resumen' },
        { id: 2, name: 'Datos Personales' },
        { id: 3, name: 'Pagos' },
        ],
        []
    ); */
    const roles: Role[] = useMemo(() => {
        if (perfil === 'admin') {
            return [
                { id: 1, name: 'Admin. Usuarios' },
                { id: 2, name: 'Admin. Contenido' },
            ];
        }
    
        return [
            { id: 1, name: 'Resumen' },
            { id: 2, name: 'Datos Personales' },
            { id: 3, name: 'Pagos' },
        ];
    }, [perfil]);   

    const selectTab = useCallback(        
        (role: Role) => {
        setTabSelect(role);
        },
        [setTabSelect]
    );

    return {
        roles,
        tabSelect,
        selectTab,
    };
};
